import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { api, selectors } from '../../../../redux/products/category';
import PVShopWrapper from '../../PVShopWrapper';
import getShopMenu from '../../../../redux/menus/functions';
import PVPaging from '../../../Shared/PVPaging';
import PVListingToolbar from '../Shared/PVListingToolbar';
import '../Shared/style.css';
import { selectActiveDealerKey } from '../../../../redux/userProfile/selectors';

const getPosition = (pageSize, displayPage) => pageSize * (displayPage - 1);
const categoryPath = '';
const PVListingProduct = loadable(() => import('../Shared/PVListingProduct'), {
    fallback: <div className="pv-spinner sm" />,
});
const PVProductList = (props) => {
    const {
        match,
        products,
        apiGetCategory,
        category,
        categoryIsReady,
        getLeftMenu,
        isCategoryDataInvalid,
        dealerKey,
    } = props;
    const history = useHistory();
    const isMounted = useRef(null);

    const [leftMenu, setLeftMenu] = useState([]);
    const [displayPage, setDisplayPage] = useState(1);
    const [numProducts, setNumProducts] = useState(10);
    const [activeProducts, setActiveProducts] = useState([]);
    const [displaySliceId, setDisplaySliceId] = useState(0);
    const [showPage, setShowPage] = useState(false);
    const [showLoading, setShowLoading] = useState(true);

    const params = match.params || {};
    const { TotalProducts, Name, ParentName, WebDescription } = category;

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const getDisplaySlice = (n, page) => {
        let section = [...products];
        const position = getPosition(n, page);
        let take = n;
        if (page > 1 && page * n >= TotalProducts) {
            take = products.length - position;
        }
        section = section.slice(position, take + position);
        return section;
    };

    const getDisplayLength = (n, page) => {
        const len = (products.length % n) * page === 0 ? n : (products.length % n) * page;
        return len;
    };

    const breadcrumbs = [
        {
            sortOrder: 18,
            linkTarget: '/',
            linkText: 'Home',
        },
        {
            sortOrder: 19,
            linkTarget: `/Shop/Category/${match.params.categoryName}`,
            linkText: addSpacesToCamelCase(match.params.categoryName),
        },
        {
            sortOrder: 20,
            linkTarget: '#',
            linkText: category.Name,
        },
    ];

    const breadcrumbssub = [
        {
            sortOrder: 18,
            linkTarget: '/',
            linkText: 'Home',
        },
        {
            sortOrder: 19,
            linkTarget: `/Shop/Category/${match.params.categoryName}`,
            linkText: addSpacesToCamelCase(match.params.categoryName),
        },
        {
            sortOrder: 20,
            linkTarget: `/Shop/Category/${match.params.categoryName}/${match.params.subcategory}`,
            linkText: addSpacesToCamelCase(match.params.subcategory),
        },
        {
            sortOrder: 21,
            linkTarget: '#',
            linkText: category.Name,
        },
    ];

    function addSpacesToCamelCase(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2');
    }

    useEffect(() => {
        /* Effect to show proper page status */
        if (categoryIsReady && category.Name && isMounted.current) {
            setShowLoading(false);
            setShowPage(true);
        }
        if (categoryIsReady && !category.Name) {
            history.replace('/Error/404');
        }
        if (!categoryIsReady && isMounted.current) {
            setShowLoading(true);
            setShowPage(false);
        }
    }, [categoryIsReady]);

    useEffect(() => {
        if (ParentName && isMounted.current) {
            /*Effect to get menus in redux once we know the display name*/
            const items = getLeftMenu(ParentName);
            setLeftMenu(items);
        }
    }, [ParentName]);

    useEffect(() => {
        /*Effect to retrieve products on display page on first visits)*/
        /*And to reset vars when changing routes*/
        //if (
        //    !products ||
        //    ((products.length === 0 || products.length < TotalProducts) && displayPage === 1)
        //) {
        if (isMounted.current) {
            setActiveProducts([]);
            setDisplaySliceId(1);
            setDisplayPage(1);
            apiGetCategory(match.params.categoryName, match.params.subcategory, match.params.subsubcategory, numProducts, 0);
        }
        //}
    }, [match, dealerKey]);

    useEffect(() => {
        /*Effect to retrieve products on page change*/
        const productsLen = products.length || 0;
        if ((productsLen < TotalProducts && displayPage !== 1) || isCategoryDataInvalid) {
            if (isCategoryDataInvalid && displayPage !== 1) {                
                apiGetCategory(params.categoryName, params.subcategory, params.subsubcategory, numProducts, 0);
            }
            apiGetCategory(params.categoryName, params.subcategory, params.subsubcategory, numProducts, displayPage - 1);            
        }
    }, [displayPage]);

    useEffect(() => {
        const section = getDisplaySlice(numProducts, displayPage);
        const notBlanks = section.filter((x) => ((x || {}).ItemID || '').length > 0);
        if (notBlanks.length > 0 && isMounted.current) {
            setActiveProducts(notBlanks || []);
            setDisplaySliceId(displayPage);
        }
    }, [TotalProducts, displayPage, displaySliceId, products, match]);

    const setCurrentPage = (p) => {
        window.scrollTo(0, 0);
        if (isMounted.current) {
            setDisplayPage(Math.max(p, 0));
        }
    };

    const changePaging = (n) => {
        if (n !== numProducts && isMounted.current) {
            const newNumber = n === '0' ? TotalProducts - 1 : Number(n);
            setNumProducts(newNumber);
            setDisplayPage(1);
            const section = getDisplaySlice(newNumber, displayPage);
            const sectionLength = getDisplayLength(newNumber, displayPage);
            const notBlanks = section.filter((x) => ((x || {}).ItemID || '').length > 0);
            if (notBlanks.length !== sectionLength) {                
                apiGetCategory(params.categoryName, params.subcategory, params.subsubcategory, Number(n), displayPage - 1);
            } else if (isMounted.current) {
                setActiveProducts(notBlanks || []);
                setDisplaySliceId(displayPage);
            }
        }
    };

    return (
        <React.Fragment>
            {showPage && (
                <PVShopWrapper
                    heading={ParentName}
                    menu={leftMenu}
                    breadcrumbs={(params.subsubcategory == null) ? breadcrumbs : breadcrumbssub}
                    categorypath={categoryPath}
                >
                    <h4 className="pv-product-category-web-description">
                        {WebDescription}
                    </h4>
                    <PVListingToolbar
                        pagingOptions={{
                            opts: [
                                { id: 0, value: 10, display: '10' },
                                { id: 1, value: 20, display: '20' },
                                { id: 2, value: 50, display: '50' },
                                { id: 3, value: 100, display: '100' },
                            ],
                            label: 'Show',
                            selectedVal: numProducts,
                            use: true,
                            fieldName: 'productPaging',
                            changeFunc: changePaging,
                        }}
                    />

                    <div className="products products-list">
                        {isCategoryDataInvalid
                            ? 'reloading to get dealer-specific data ...'
                            : activeProducts.map((product) => {
                                  return (
                                      <PVListingProduct key={product.ItemID} product={product} />
                                  );
                              })}
                        <PVPaging
                            currentPage={displayPage}
                            pageSize={numProducts}
                            totalRecords={TotalProducts || 0}
                            handleClick={(p) => setCurrentPage(p)}
                        />
                    </div>
                </PVShopWrapper>
            )}
            {showLoading && <div className="pv-spinner lg" />}
        </React.Fragment>
    );
};

PVProductList.propTypes = {
    /* eslint-disable  react/forbid-prop-types */
    products: PropTypes.arrayOf(PropTypes.object),
    category: PropTypes.object,
    /* eslint-enable  react/forbid-prop-types */
    categoryIsReady: PropTypes.bool,
    match: ReactRouterPropTypes.match.isRequired,
    isCategoryDataInvalid: PropTypes.bool.isRequired,
    dealerKey: PropTypes.string.isRequired,
    getLeftMenu: PropTypes.func.isRequired,
    apiGetCategory: PropTypes.func.isRequired,
};

PVProductList.defaultProps = {
    products: [],
    category: {},
    categoryIsReady: false,
};

const mapStateToProps = (state, ownProps) => {
    const params = ownProps.match.params || {};
    const selectorOptions = { parent: params.categoryName, subcategory: params.subcategory };
    return {
        category: selectors.selectSubcategory(state, selectorOptions),
        categoryIsReady: selectors.selectSubcategoryReady(state, selectorOptions),
        products: selectors.selectSubcategoryProducts(state, selectorOptions),
        isCategoryDataInvalid: selectors.selectCategorySliceInvalid(state),
        dealerKey: selectActiveDealerKey(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        /* eslint-disable  no-unused-vars */
        apiGetCategory: (parentCategory, subcategory, subsubcategory, numProducts, page) => {
            /* eslint-enable  no-unused-vars */
            if (subsubcategory == null) {
                dispatch(api.getProductsForCategory(parentCategory, subcategory, 600, 0));
            }
            else {
                dispatch(api.getProductsForCategory(parentCategory, subcategory, subsubcategory, 600, 0));
            }
            
        },
        getLeftMenu: (categoryName) => dispatch(getShopMenu(categoryName)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PVProductList);
